<mat-form-field appearance="outline" class="text-input" [class.warning]="hasOnlyAsyncWarnings(input.errors)">
  <mat-label [innerHTML]="option?.title ?? 'Zip Code'"></mat-label>
  <input type="text" autocomplete="postal-code" matInput pattern="^\d{5}$" [errorStateMatcher]="errorMatcher" [formControl]="input" />

  <mat-error>
    <lib-form-control-error [control]="input" [checkTouched]="true" [errorHandlers]="errorHandlers"></lib-form-control-error>
  </mat-error>
</mat-form-field>
